import { Context } from '@nuxt/types'
import { Auth0Scheme } from '@nuxtjs/auth-next'

export const getAuthToken = (auth: Context['$auth']) => {
  return (auth?.strategy as Auth0Scheme)?.token?.get() ?? ''
}
